import { RequestDefinition } from 'libraries/front-end-core/core/Api'

import {
  toLegislationAct,
  toLegislationActs,
  toLegislationFolders,
  toLegislationReference,
  toLegislationRelatedQas,
  toLegislationSearch,
  toTakeoverCode,
  toTakeoverCodeVersions
} from './transforms'

import {
  URL_LEGISLATION_ACT,
  URL_LEGISLATION_ACTS,
  URL_LEGISLATION_FOLDERS,
  URL_LEGISLATION_REFERENCE,
  URL_LEGISLATION_RELATED_QAS,
  URL_LEGISLATION_SEARCH,
  URL_LEGISLATION_SEARCH_PREPAY,
  URL_TAKEOVER_CODE,
  URL_TAKEOVER_CODE_VERSIONS
} from 'constants/urls'

import {
  LEGISLATION_ACT,
  LEGISLATION_ACTS,
  LEGISLATION_FOLDERS,
  LEGISLATION_REFERENCE,
  LEGISLATION_RELATED_QAS,
  LEGISLATION_SEARCH,
  LEGISLATION_SEARCH_PREPAY,
  TAKEOVER_CODE,
  TAKEOVER_CODE_VERSIONS
} from 'constants/requests'

export const LegislationAct = new RequestDefinition({
  name: LEGISLATION_ACT,
  url: URL_LEGISLATION_ACT,
  transform: toLegislationAct
})

export const LegislationActs = new RequestDefinition({
  name: LEGISLATION_ACTS,
  url: URL_LEGISLATION_ACTS,
  transform: toLegislationActs
})

export const LegislationFolders = new RequestDefinition({
  name: LEGISLATION_FOLDERS,
  url: URL_LEGISLATION_FOLDERS,
  transform: toLegislationFolders
})

export const LegislationReference = new RequestDefinition({
  name: LEGISLATION_REFERENCE,
  url: URL_LEGISLATION_REFERENCE,
  transform: toLegislationReference
})

export const LegislationRelatedQas = new RequestDefinition({
  name: LEGISLATION_RELATED_QAS,
  url: URL_LEGISLATION_RELATED_QAS,
  transform: toLegislationRelatedQas
})

export const LegislationSearch = new RequestDefinition({
  name: LEGISLATION_SEARCH,
  url: URL_LEGISLATION_SEARCH,
  transform: toLegislationSearch
})

export const LegislationSearchPrepay = new RequestDefinition({
  name: LEGISLATION_SEARCH_PREPAY,
  url: URL_LEGISLATION_SEARCH_PREPAY,
  transform: toLegislationSearch
})

export const TakeoverCode = new RequestDefinition({
  name: TAKEOVER_CODE,
  url: URL_TAKEOVER_CODE,
  transform: toTakeoverCode
})

export const TakeoverCodeVersions = new RequestDefinition({
  name: TAKEOVER_CODE_VERSIONS,
  url: URL_TAKEOVER_CODE_VERSIONS,
  transform: toTakeoverCodeVersions
})
